import React from 'react'
import { useHistory } from 'react-router'

import {
  IUserResultsProps,
  OmniSearchUser,
} from '@new/__global/components/OmniSearch/OmniSearch.types'
import { GuestInfoTabs } from '@new/domains/people/guests/Guests.types'
import { GuestsStore } from '@new/domains/people/guests/stores/GuestsStore'

import { mountRouteUrl, ROUTES } from '@routes'

import ResultsTemplate from './ResultsTemplate'
import { UserDetail } from './UserDetail'

function UsersResults({
  activeIndex,
  enabledNavigation,
  homes,
  setIndex,
  users,
  totalCount,
  searchTerm,
}: IUserResultsProps): JSX.Element {
  const history = useHistory()

  const onClick = ({ id }: OmniSearchUser) => {
    history.push(mountRouteUrl(ROUTES.guests.path, {}, { guestId: id }))
    GuestsStore.setGuestId(id)
    GuestsStore.setGuestInfoTab(GuestInfoTabs.GUEST_INFO)
  }

  return (
    <ResultsTemplate
      activeIndex={activeIndex - homes.length}
      data={users}
      enabledNavigation={enabledNavigation}
      baseUrl={ROUTES.guests.path}
      queryParamKey="filter"
      searchTerm={searchTerm}
      totalCount={totalCount}
      onClick={onClick}
      setIndex={setIndex}
      titlePrefix={users.length === 1 ? 'user' : 'users'}
      renderChildren={(user: OmniSearchUser) => <UserDetail user={user} />}
    />
  )
}

export default UsersResults
